import { render, staticRenderFns } from "./asideVideo.vue?vue&type=template&id=f26acbb8&scoped=true&"
import script from "./asideVideo.vue?vue&type=script&lang=js&"
export * from "./asideVideo.vue?vue&type=script&lang=js&"
import style0 from "./asideVideo.vue?vue&type=style&index=0&id=f26acbb8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f26acbb8",
  null
  
)

export default component.exports